import * as React from 'react';
import useStyles from './Auth0MockContainer.styles';
import { useTheme } from 'react-jss';
import { CustomCiamUiTheme } from '../../../theme';
import { AlignLogo } from '../../pages/SetUsernamePage/AlignLogo';
import { Auth0Footer } from '../../molecules/Auth0Footer';
import { StaffLoginInstruction } from '../StaffLoginInstruction';
import { Auth0Widget } from '../../molecules/Auth0Widget';
import { ResellerLogo } from '../../pages/SetUsernamePage/ResellerLogo';
import { AxiLogo } from '../../pages/SetUsernamePage/AxiLogo';
import { ExocadFooter } from '../../molecules/ExocadFooter';

export interface IAuth0MockContainerProps {
  description?: JSX.Element;
  title?: JSX.Element;
  isError?: boolean;
  children?: JSX.Element;
  renderBackLink?: JSX.Element;
  showEmailIcon?: boolean;
  showStaffProviderLink?: boolean;
  uiTheme?: 'default' | 'exocad' | 'axi';
}

const Auth0MockContainer: React.FC<IAuth0MockContainerProps> = ({
  description,
  title,
  isError = false,
  children,
  renderBackLink,
  showEmailIcon,
  showStaffProviderLink = true,
  uiTheme = 'default',
}) => {
  const theme = useTheme<CustomCiamUiTheme>();
  const classes = useStyles({ theme });
  return (
    <div className={classes.root}>
      <div className={classes.wrapper}>
        <div className={classes.logo}>
          {uiTheme === 'default' ? (
            <AlignLogo />
          ) : uiTheme === 'axi' ? (
            <AxiLogo />
          ) : (
            <ResellerLogo />
          )}
        </div>
        <Auth0Widget
          description={description}
          title={title}
          isError={isError}
          renderBackLink={renderBackLink}
          showEmailIcon={showEmailIcon}
        >
          {children}
        </Auth0Widget>
        {!showStaffProviderLink && <StaffLoginInstruction />}
        <div className={classes.footer}>
          {uiTheme === 'default' || uiTheme === 'axi' ? (
            <Auth0Footer
              privacyLink={'https://www.invisalign.com/global/privacy-policy'}
              termsOfUseLink={'https://www.invisalign.com/global/terms-of-use'}
            />
          ) : (
            <ExocadFooter
              privacyLink={'https://my.exocad.com/privacy-policy'}
              termsOfUseLink={'https://my.exocad.com/terms-of-use'}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Auth0MockContainer;
